import { createRoot } from 'react-dom/client';
import { App } from './ui/App';

// DE: Einstiegspunkt: hängt die App an das Element #app aus index.html.
// EN: Entry point: mounts the app on the #app element from index.html.
const root = document.getElementById('app');
if (root) createRoot(root).render(<App />);
